angular.module('elfium').controller('taskListController', ['$rootScope', '$scope', '$filter', 'taskService', 'elfiumToastrService', 'elfiumGetNumberFilter', 'elfiumListFilterFactory',
    function ($rootScope, $scope, $filter, taskService, elfiumToastrService, elfiumGetNumberFilter, elfiumListFilterFactory) {
        var that = this;
        $scope.filters = {
            obchodniPripad: {}
        };
        $scope.dateFilters = {
            termin: {}
        };
        $scope.selectedSort = {};
        $scope.priorityOptions = {
            '': undefined, 
            'ano': 'true', 
            'ne': 'false'
        };
        that.getTasks = function () {
            taskService.getTasks().then(function (tasks) {
                that.listFilter = new elfiumListFilterFactory($scope, tasks, $scope.filters, 'tasks', $scope.dateFilters);
            }, elfiumToastrService.error);
        };
        $scope.openTaskDetailModal = function (taskId) {
            taskService.openTaskDetailModal(taskId).then(that.getTasks);
        };
        $scope.getTotal = function () {
            var total = 0;
            angular.forEach($scope.tasks, function (task) {
                total += elfiumGetNumberFilter(task.castka);
            });
            return total;
        };
        var rootscopeListnerer = $rootScope.$on('refreshTaskList', that.getTasks);
        $scope.$on('$destroy', function() {
            rootscopeListnerer();
        });
        that.getTasks();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/task/taskListController.ts